import { Loader } from '@googlemaps/js-api-loader';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'next-i18next';
import { ILocationItems } from '@features/showroom/typescript';
import styles from '@features/showroom/sections/Map/Components/GoogleMap/GoogleMap.styles';
import logger from '@utils/logger';
import getPublicEnv from '@utils/getPublicEnv';
type PropsType = {
  mapLocations: Array<ILocationItems>;
};
const GoogleMap = ({
  mapLocations
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const googlemapRef = useRef<HTMLDivElement | null>(null);
  const geocodeAddress = (google, address): Promise<typeof google> => new google.maps.Geocoder().geocode({
    address
  });
  useEffect(() => {
    const loader = new Loader({
      apiKey: getPublicEnv('NEXT_PUBLIC_GOOGLE_MAP_API_KEY'),
      version: 'weekly'
    });
    const infoWindow = (google, location) => {
      const {
        name,
        address,
        phone
      } = location;
      return new google.maps.InfoWindow({
        content: `<div class="map-info"><h3>${name}</h3><p>${address}</p><p>${phone && `${t('phone')} ${phone}`}</p></div>`
      });
    };
    loader.load().then(() => {
      const {
        google
      } = window;
      const bounds = new google.maps.LatLngBounds();
      if (!googlemapRef.current) return;
      const map = new google.maps.Map(googlemapRef.current, {
        zoom: mapLocations.length > 1 ? 10 : 12
      });
      mapLocations.forEach(location => {
        const description = infoWindow(google, location);
        const geocode = geocodeAddress(google, location.address);
        geocode.then(response => {
          const position = response.results[0].geometry.location;
          map.setCenter(position);
          const marker = new google.maps.Marker({
            map,
            position,
            title: location.name
          });
          bounds.extend(position);
          marker.addListener('click', () => {
            description.open({
              anchor: marker,
              map,
              shouldFocus: false
            });
          });
        }).catch(error => {
          logger.debug(`Handle google map rejected promise (${error}) here.`);
        });
      });
    });
  }, [mapLocations, t]);
  return <div sx={styles.googleMap} id="map" ref={googlemapRef} />;
};
export default GoogleMap;